import baked from './baked.json';
import { CAMP_PROPS, ENEMY_VISUALS, FOREST_PROPS, isSharp, KAYKIT_HEROES, RUN_PROPS } from './visuals';

/**
 * Jak obrabiamy dany model przy wczytaniu (albo z góry, w `npm run asset:bake`):
 *  subdivide — zaokrąglenie brył podziałem Loopa + miękkie cieniowanie (dekoracje),
 *  subdivide-skinned — to samo, ale tylko ciało postaci (broń i dodatki zostają ostre),
 *  smooth — tylko miękkie cieniowanie (rzeczy, które mają zostać kanciaste).
 */
export type Processing = 'subdivide' | 'subdivide-skinned' | 'smooth';

export function processingPlan(): Map<string, Processing> {
  const plan = new Map<string, Processing>();
  for (const p of [...RUN_PROPS, ...FOREST_PROPS, ...CAMP_PROPS]) plan.set(p.path, isSharp(p.path) ? 'smooth' : 'subdivide');
  // Postacie z AI (models/characters) są już gęste i gładkie — wygładzamy tylko kanciaste KayKit.
  for (const path of [...Object.values(KAYKIT_HEROES), ...Object.values(ENEMY_VISUALS).map((v) => v.model)]) plan.set(path, 'subdivide-skinned');
  return plan;
}

/** Wersja algorytmu obróbki — zmiana unieważnia upieczone pliki. */
export const BAKE_VERSION = 1;

const bakedPaths = new Set(baked.version === BAKE_VERSION ? (baked.paths as string[]) : []);

/** Ścieżka pliku do wczytania: upieczona wersja (już obrobiona), jeśli istnieje. */
export function bakedFile(path: string): string | null {
  return bakedPaths.has(path) ? `baked/${path.replace(/\.gltf$/, '.glb')}` : null;
}
